@if (!addingRule && !addingTimeFrame) {
  @let brandingData = (brandingService.brandingData$ | async) || defaultBrandingSettings;
  @let secondsText = 'ANSWERING_RULES_PREFERENCES.SECONDS' | translate;
  <div
    class="answering-rules-container"
    [ngClass]="{ 'audio-settings-container-overflow': false }">
    <div class="subheader">{{ 'ANSWERING_RULES_PREFERENCES.RING_OPTIONS' | translate }}</div>
    <div class="ring-options">
      <div class="label">{{ 'ANSWERING_RULES_PREFERENCES.RING_FOR' | translate }}</div>
      <mat-form-field
        class="input-40"
        style="width: 240px"
        appearance="outline">
        <input
          matInput
          #delayInput
          type="number"
          min="5"
          max="7200"
          style="width: 210px"
          [formControl]="ringDuration" />
        <span
          [style]="'position: relative; right: ' + (206 - 10 * (secondsText.length + delayInput.value.length)) + 'px;'"
          matTextSuffix>
          {{ secondsText }}
        </span>
        <mat-hint class="hint small-text">{{ 'ANSWERING_RULES_PREFERENCES.VALID_RANGE_SECONDS' | translate }}</mat-hint>
      </mat-form-field>
    </div>
    <div class="return-busy-if-on-call-options">
      <div class="label">{{ 'ANSWERING_RULES_PREFERENCES.RETURN_BUSY_CALL' | translate }}</div>
      <div class="slide-toggle">
        <mat-slide-toggle
          [formControl]="returnBusyIfOnCall"
          [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]"></mat-slide-toggle>
        <mat-hint class="hint small-text"
          >{{ 'ANSWERING_RULES_PREFERENCES.ALLOWS_USER_CONTROL_MULTIPLE_CALLS' | translate }}
        </mat-hint>
      </div>
    </div>
    <div class="ring-options">
      <div class="label">{{ 'ANSWERING_RULES_PREFERENCES.AUTO_ANSWER_INCOMING_CALLS' | translate }}</div>
      <div class="slide-toggle">
        <mat-slide-toggle
          [checked]="autoAnswerIncomingCalls.value"
          [formControl]="autoAnswerIncomingCalls"
          [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]">
        </mat-slide-toggle>
        <mat-hint class="small-text"
          >{{ 'ANSWERING_RULES_PREFERENCES.INCOMING_CALLS_AUTOMATICALLY_ANSWERED' | translate }}
        </mat-hint>
      </div>
    </div>
    <div class="ring-options">
      <div class="label">{{ 'ANSWERING_RULES_PREFERENCES.AUTO_ANSWER_TIME' | translate }}</div>
      <mat-form-field
        class="input-40"
        style="width: 240px"
        appearance="outline">
        <input
          matInput
          #delayInputAnswer
          type="number"
          min="0"
          max="7200"
          style="width: 210px"
          [formControl]="autoAnswerTime" />
        <span
          [style]="
            'position: relative; right: ' + (206 - 10 * (secondsText.length + delayInputAnswer.value.length)) + 'px;'
          "
          matTextSuffix
          >{{ secondsText }}</span
        >
        <mat-hint class="hint small-text"
          >{{ 'ANSWERING_RULES_PREFERENCES.INCOMING_CALLS_ANSWERED_IMMEDIATELY' | translate }}
        </mat-hint>
      </mat-form-field>
    </div>
    <div class="subheader">{{ 'ANSWERING_RULES_PREFERENCES.ANSWERING_RULES' | translate }}</div>
    @if (answeringRules.length === 0 && (answeringRulesService.answeringRulesLoading$ | async) === false) {
      <div class="text">
        {{ 'ANSWERING_RULES_PREFERENCES.WHEN_NO_ANSWERING_RULES' | translate }}
      </div>
    }
    @if (answeringRulesService.answeringRulesLoading$ | async) {
      <div class="spinner-wrapper">
        <mat-spinner diameter="48"></mat-spinner>
      </div>
    } @else {
      <div
        class="answering-rules"
        cdkDropList
        cdkScrollable
        (cdkDropListDropped)="drop($event)">
        @for (rule of answeringRules; track rule.timeFrame; let i = $index) {
          <app-answering-rule
            cdkDrag
            [answeringRule]="rule"
            (edit)="editRule(i)"
            (delete)="confirmDeleteRule(i)">
          </app-answering-rule>
        }
      </div>
      @if (appConfigService.features[AppFeature.ModifyAnsweringRules]) {
        <div
          class="add-option"
          (click)="addingRule = !addingRule">
          <div
            appBrandingColor
            [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
            styleType="color">
            {{ 'ANSWERING_RULES_PREFERENCES.ADD_RULE' | translate }}
          </div>
          <mat-icon
            appBrandingColor
            [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
            styleType="color"
            >add_box</mat-icon
          >
        </div>
      }
    }

    <div class="subheader time-frames-section">
      <div>{{ 'ANSWERING_RULES_PREFERENCES.TIME_FRAMES' | translate }}</div>
      <mat-radio-group
        color="primary"
        [(ngModel)]="filtered"
        (change)="filterTimeFrames()">
        <mat-radio-button
          disableRipple
          [value]="false"
          [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]">
          {{ 'ANSWERING_RULES_PREFERENCES.ALL' | translate }}
        </mat-radio-button>
        <mat-radio-button
          disableRipple
          [value]="true"
          [style]="'margin-left: 16px'"
          [style.--branding-color]="brandingData[BrandingField.FieldColorFontIconsListAreaItems]">
          {{ 'ANSWERING_RULES_PREFERENCES.PERSONAL' | translate }}
        </mat-radio-button>
      </mat-radio-group>
    </div>
    @if (answeringRulesService.timeFramesLoading$ | async) {
      <div class="spinner-wrapper">
        <mat-spinner diameter="48"></mat-spinner>
      </div>
    }
    @if ((answeringRulesService.timeFramesLoading$ | async) === false) {
      <div class="time-frames-header small-text">
        <span>{{ 'ANSWERING_RULES_PREFERENCES.NAME' | translate }}</span>
        <span>{{ 'ANSWERING_RULES_PREFERENCES.DESCRIPTION' | translate }}</span>
        <span>{{ 'ANSWERING_RULES_PREFERENCES.OWNER' | translate }}</span>
      </div>
      <div class="time-frames">
        @for (timeFrame of filteredTimeFrames; track $index; let i = $index) {
          <div class="time-frame">
            <div>{{ timeFrame.time_frame }}</div>
            <div>{{ timeFrameDescription(timeFrame) }}</div>
            <div>
              @if (timeFrame.owner === '*') {
                {{ 'ANSWERING_RULES_PREFERENCES.SHARED' | translate }}
              } @else {
                {{ 'ANSWERING_RULES_PREFERENCES.PERSONAL' | translate }}
              }
            </div>
            <div
              class="buttons"
              [ngClass]="{
                disabled: timeFramesEditingDisabled,
              }">
              @if (timeFrame.owner !== '*' || answeringRulesService.isCurrentUserOfficeManager) {
                <mat-icon
                  (click)="editOrCopyTimeFrame(i)"
                  appBrandingColor
                  [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
                  styleType="color">
                  edit_outline
                </mat-icon>
              }
              @if (timeFrame.owner === '*' && !answeringRulesService.isCurrentUserOfficeManager) {
                <mat-icon
                  matTooltip="{{ 'ANSWERING_RULES_PREFERENCES.COPY_TIMEFRAME_TOOLTIP' | translate }}"
                  matTooltipShowDelay="500"
                  (click)="editOrCopyTimeFrame(i)"
                  appBrandingColor
                  [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
                  styleType="color">
                  content_copy
                </mat-icon>
              }
              <mat-icon
                [ngClass]="{
                  disabled:
                    timeFrame.in_use || (timeFrame.owner === '*' && !answeringRulesService.isCurrentUserOfficeManager),
                }"
                [matTooltip]="deleteIconTooltipText(timeFrame)"
                matTooltipShowDelay="500"
                (click)="
                  !timeFrame.in_use &&
                    (timeFrame.owner !== '*' || answeringRulesService.isCurrentUserOfficeManager) &&
                    confirmDeleteTimeFrame(i)
                "
                appBrandingColor
                [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
                styleType="color">
                delete_outline
              </mat-icon>
            </div>
          </div>
        }
      </div>
      <div
        class="add-option"
        [ngClass]="{
          disabled: timeFramesEditingDisabled,
        }"
        (click)="addingTimeFrame = !addingTimeFrame">
        <div
          appBrandingColor
          [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
          styleType="color">
          {{ 'ANSWERING_RULES_PREFERENCES.ADD_TIME_FRAME' | translate }}
        </div>
        <mat-icon
          appBrandingColor
          [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
          styleType="color"
          >add_box</mat-icon
        >
      </div>
    }
  </div>
  <div class="main-buttons">
    <button
      mat-button
      type="button"
      color="primary"
      (click)="onCancel()"
      appBrandingColor
      [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
      styleType="color">
      {{ 'ANSWERING_RULES_PREFERENCES.CANCEL' | translate }}
    </button>
    <button
      mat-raised-button
      type="button"
      color="primary"
      [disabled]="
        (!reordered &&
          autoAnswerIncomingCalls.pristine &&
          ringDuration.pristine &&
          autoAnswerTime.pristine &&
          returnBusyIfOnCall.pristine) ||
        ringDuration.invalid ||
        loading
      "
      (click)="onSave()"
      appBrandingColor
      [brandingField]="BrandingField.FieldColorFontIconsListAreaItems">
      @if (loading) {
        <mat-spinner diameter="24"></mat-spinner>
      } @else {
        <span>{{ 'ANSWERING_RULES_PREFERENCES.SAVE' | translate }}</span>
      }
    </button>
  </div>
}
@if (addingRule) {
  <app-add-answering-rule
    [answeringRule]="actionRule"
    [timeFramesUsedByMe]="timeFramesUsedByMe"
    (cancelChanges)="onSubpanelCancel()">
  </app-add-answering-rule>
}
@if (addingTimeFrame) {
  <app-add-timeframe
    [timeFrame]="actionTimeFrame"
    (cancelChanges)="onSubpanelCancel()">
  </app-add-timeframe>
}
